<template>
  <b-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.name"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-if="filter2 === '2'">
          <b-form-input
            v-model="form.email"
            type="text"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>

    <!--TABLE -->
    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>
      <template v-slot:cell(role)="data">
        <span v-if="data.value == 1">Admin</span>
        <span v-if="data.value == 2">Stokis</span>
        <span v-if="data.value == 3">Home Dealer</span>
        <span v-if="data.value == 4">Agent</span>
        <span v-if="data.value == 5">Distributor</span>
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickSubDealerView(data.item.id)"
            >VIEW</b-button
          >
        </span>
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
    ></b-pagination>
  </b-card>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  data() {
    return {
      items: [],
      form: {
        user_id: this.$route.query.id,
        name: null,
        email: null,
        page: 1
      },
      isLoading: false,
      fullPage: true,
      indexsearch: 1,
      filter2: null,
      select: {
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Name", value: "1" },
          { text: "Email", value: "2" }
        ]
      },
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      }
    };
  },
  components: {
    Loading
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  created() {
    this.getDownlineAdmin();
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    // items: {
    //   type: Array,
    //   required: true
    // },
    type: {
      type: String,
      required: false,
      default: "User"
    },
    stockist_id: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    }
  },

  methods: {
    // onClickView() {
    //   this.$router.push({ path: `stockout_view_user` });
    // },
    onClickSubDealerView(id) {
      this.$router.push({
        path: `home_dealer_admin_next?id=${id}`
      });
    },
    getDownlineAdmin() {
      this.items = [];
      this.$store
        .dispatch("getIndividualDownline", this.$route.query.id)
        .then(res => {
          if (res.data.response && res.data.response.code === 100) {
            res.data.data.data.forEach(element => {
              this.items.push({
                name: element.name,
                role: element.access_lvl,
                id: element.user_id
              });
            });
          }
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
    },
    onClickSearch() {
      this.isLoading = true;
      this.form.page = this.indexsearch;
      this.form.user_id = this.$route.query.id;

      if (this.filter2 === null) {
        this.getDownlineAdmin();
      } else {
        this.$store
          .dispatch("searchIndividualDownline", this.form)
          .then(res => {
            this.isLoading = false;
            this.items = [];
            if (res.data.response.code === 100) {
              this.isLoading = false;
              res.data.data.data.forEach(element => {
                this.items.push({
                  name: element.name,
                  role: element.access_lvl,
                  id: element.user_id
                });
              });
            }
            this.pagination.total = res.data.data.total;
            this.pagination.current = res.data.data.current_page;
            this.pagination.perPage = res.data.data.per_page;
            this.pagination.startIndex = res.data.data.from;
            this.indexsearch = res.data.data.current_page;
          });
      }
    },
    onChangePage(index) {
      this.pagination.current = index;
      if (this.filter2 === null) {
        this.getDownlineAdmin();
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        this.onClickSearch();
      }
    },
    resetFilter() {
      this.form.email = null;
      this.form.name = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.email = null;
      this.form.name = null;
      this.getDownlineAdmin();
    },
    resetIndex() {
      this.indexsearch = 1;
    }
  }
};
</script>
<style lang="css" scoped></style>
